module.exports = __webpack_public_path__ + "static/img/logo-todomath-for-web-en@2x.1aebf79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-todomath-for-web-en@2x.png
// module id = aNYP
// module chunks = 18